<template>
  <div :class="{ 'pb-tag': true, [color]: true }">
    <slot />
  </div>
</template>
<script>
export default {
  name: "PbTag",
  props: {
    color: {
      type: String, // "error" | "success" | "warn" | "disabled" | "info"
      default: () => "disabled",
    },
  },
  methods: {},
};
</script>
<style lang="scss">
@import "~styles/color";

.pb-tag {
  font-size: 1.2rem;
  padding: 0.45rem 0.8rem;
  display: inline-block;
  border-radius: 5px;

  &.error {
    @extend %error_setting;
  }

  &.success {
    @extend %success_setting;
  }

  &.info {
    @extend %info_setting;
  }

  &.warn {
    @extend %warn_setting;
  }
}
</style>
